import { useState } from 'react'
import useEditInfo from './hooks/useEditInfo'
import Name from './name'
import Date from './date'
import Price from './price'
interface IBodyProps {
    name: string
    bankBalance: number
    interval: string
    shareValue: number
    dayOfDuetion: number
    type: string
    notificationAnnounce: string
    smsAnnounce: string
    id: string | undefined
    refetch: () => void
    imageId: number
}
export default function Body({
    name,
    bankBalance,
    interval,
    shareValue,
    dayOfDuetion,
    type,
    notificationAnnounce,
    smsAnnounce,
    id,
    refetch,
    imageId,
}: IBodyProps) {
    const { mutate } = useEditInfo(refetch)
    return (
        <div className=" w-full">
            <Name
                name={name}
                bankBalance={bankBalance}
                interval={interval}
                shareValue={shareValue}
                dayOfDuetion={dayOfDuetion}
                type={type}
                notificationAnnounce={notificationAnnounce}
                smsAnnounce={smsAnnounce}
                id={id}
                refetch={refetch}
                imageId={imageId}
                mutate={mutate}
            />
            <Date
                name={name}
                bankBalance={bankBalance}
                interval={interval}
                shareValue={shareValue}
                dayOfDuetion={dayOfDuetion}
                type={type}
                notificationAnnounce={notificationAnnounce}
                smsAnnounce={smsAnnounce}
                id={id}
                refetch={refetch}
                imageId={imageId}
                mutate={mutate}
            />
            <Price
                name={name}
                bankBalance={bankBalance}
                interval={interval}
                shareValue={shareValue}
                dayOfDuetion={dayOfDuetion}
                type={type}
                notificationAnnounce={notificationAnnounce}
                smsAnnounce={smsAnnounce}
                id={id}
                refetch={refetch}
                imageId={imageId}
                mutate={mutate}
            />
        </div>
    )
}
